import { TApiResponse } from '@/common/types/response';

import { TEventLogStoreState } from './types';

export function setEventLogs(state: TEventLogStoreState, res: TApiResponse<TEventLogStoreState['eventLogs']>) {
  state.eventLogs = res.data;
}

export function setSeverities(state: TEventLogStoreState, res: TApiResponse<TEventLogStoreState['severities']>) {
  state.severities = res.data;
}

export function setModules(state: TEventLogStoreState, res: TApiResponse<TEventLogStoreState['modules']>) {
  state.modules = res.data;
}

export function setEntityTypes(state: TEventLogStoreState, res: TApiResponse<TEventLogStoreState['entityTypes']>) {
  state.entityTypes = res.data;
}
